module.exports = __webpack_public_path__ + "img/slphouse_main8.c56de445.png";